
export default {
  props: {
    block: {
      type: Object,
      required: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mediaSide () {
      return this.block.media_side;
    },
    mediaColumn () {
      return this.block.media_column;
    },
    contentColumn () {
      return this.block.content_column;
    },
  },
};
